import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinStateOutboundConfigsIec104Push',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    connectors: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      connectorSelected: {},
      showCalculatorCA: false,
      showCalculatorIOA: false,
      calculatorCA: {
        lowHighBytes: false,
        ca1: 0,
        ca2: 0,
        result: 0
      },
      calculatorIOA: {
        lowHighBytes: false,
        ioa1: 0,
        ioa2: 0,
        ioa3: 0,
        result: 0
      },
      internalValue: this.value
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    types: function types() {
      return [{
        type: 1,
        typeString: 'M_SP_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_SP_NA'),
        timeTag: false
      }, {
        type: 3,
        typeString: 'M_DP_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_DP_NA'),
        timeTag: false
      }, {
        type: 13,
        typeString: 'M_ME_NC',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_ME_NC'),
        timeTag: false
      }, {
        type: 15,
        typeString: 'M_IT_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_IT_NA'),
        timeTag: false
      }, {
        type: 30,
        typeString: 'M_SP_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_SP_TB'),
        timeTag: true
      }, {
        type: 31,
        typeString: 'M_DP_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_DP_TB'),
        timeTag: true
      }, {
        type: 36,
        typeString: 'M_ME_TF',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_ME_TF'),
        timeTag: true
      }, {
        type: 37,
        typeString: 'M_IT_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_IT_TB'),
        timeTag: true
      }];
    },
    limitFieldsApplicable: function limitFieldsApplicable() {
      var limitsApplicableToTypes = ['M_ME_NC', 'M_ME_TF'];
      return this.types.filter(function (t) {
        return limitsApplicableToTypes.includes(t.typeString);
      }).map(function (t) {
        return t.type;
      });
    }
  }),
  watch: {
    value: {
      handler: function handler(val) {
        this.internalValue = val;
      },
      deep: true
    },
    internalValue: {
      handler: function handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
    showLimitsInput: function showLimitsInput(type) {
      if (!type) {
        return false;
      }

      return this.limitFieldsApplicable.includes(type);
    },
    changeTypeHandler: function changeTypeHandler(type) {
      if (!this.limitFieldsApplicable.includes(type)) {
        delete this.internalValue.lowerLimit;
        delete this.internalValue.upperLimit;
      }
    },
    inputAdjust: function inputAdjust(fieldName, newValue) {
      if (newValue === '') {
        delete this.internalValue[fieldName];
      }
    },
    resetCalculatorCA: function resetCalculatorCA() {
      this.calculatorCA = {
        lowHighBytes: false,
        ca1: 0,
        ca2: 0,
        result: 0
      };
    },
    resetCalculatorIOA: function resetCalculatorIOA() {
      this.calculatorIOA = {
        lowHighBytes: false,
        ioa1: 0,
        ioa2: 0,
        ioa3: 0,
        result: 0
      };
    },
    handleShowCalculatorCA: function handleShowCalculatorCA() {
      this.resetCalculatorCA();
      this.showCalculatorCA = true;
    },
    handleShowCalculatorIOA: function handleShowCalculatorIOA() {
      this.resetCalculatorIOA();
      this.showCalculatorIOA = true;
    },
    applyCalculatorCA: function applyCalculatorCA() {
      this.internalValue.ca = this.calculatorCA.result;
      this.showCalculatorCA = false;
      this.internalValue = _objectSpread({}, this.internalValue);
    },
    applyCalculatorIOA: function applyCalculatorIOA() {
      this.internalValue.ioa = this.calculatorIOA.result;
      this.showCalculatorIOA = false;
      this.internalValue = _objectSpread({}, this.internalValue);
    },
    calculateAddressCA: function calculateAddressCA() {
      var input = [this.calculatorCA.ca1, this.calculatorCA.ca2];

      if (!this.calculatorCA.lowHighBytes) {
        input = _toConsumableArray(input).reverse();
      }

      var result = input.map(function (byte, index) {
        return byte * Math.pow(256, index);
      });
      this.calculatorCA.result = result.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    },
    calculateAddressIOA: function calculateAddressIOA() {
      var input = [this.calculatorIOA.ioa1, this.calculatorIOA.ioa2, this.calculatorIOA.ioa3];

      if (!this.calculatorIOA.lowHighBytes) {
        input = _toConsumableArray(input).reverse();
      }

      var result = input.map(function (byte, index) {
        return byte * Math.pow(256, index);
      });
      this.calculatorIOA.result = result.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    }
  }
};